@if (type() !== 'hidden') {
  <div
    class="plan-banner"
    id="plan-banner"
    [ngClass]="type()"
    [class.collapsed]="collapsed"
    [matTooltipDisabled]="!collapsed"
    matTooltipClass="menu-tooltip"
    [matTooltip]="type() === 'free-trial' ? daysLeft() + ' days left' : cta()"
    matTooltipPosition="after"
  >
    @if (!collapsed) {
      @if (badge()) {
        <rv-badge
          class="plan-banner__badge"
          [text]="badge()"
          [color]="
            type() === 'billing-issue' || type() === 'expires-soon'
              ? 'red'
              : 'green'
          "
        />
      }
      <div class="title">{{ title() }}</div>
      <div class="description">
        <span>{{ description() }}</span>
      </div>
      @if (type() === 'free-trial') {
        <ng-container *ngTemplateOutlet="freeTrial"></ng-container>
      }
      <button
        class="tw-mt-6 tw-w-full tw-font-medium"
        matButton="outlined"
        (click)="actionClick()"
      >
        <mat-icon class="thin" svgIcon="upgrade-default" aria-hidden="true" />{{
          cta()
        }}
      </button>
    } @else {
      @if (type() === 'free-trial') {
        <button
          type="button"
          class="plan-banner__collapsed-pill"
          [attr.aria-label]="daysLeft() + ' days left'"
          (click)="actionClick()"
        >
          <rv-badge
            appearance="solid"
            color="green"
            size="compact"
            [text]="daysLeft().toString()"
          />
        </button>
      } @else {
        <button mat-icon-button (click)="actionClick()">
          <mat-icon class="thin" svgIcon="upgrade-default" />
        </button>
      }
    }
  </div>
}

<ng-template #freeTrial>
  <mat-progress-bar
    class="tw-my-6"
    mode="determinate"
    [value]="progressValue()"
  ></mat-progress-bar>
  <div class="tw-flex tw-items-center tw-justify-end">
    <span id="trial-plan-banner" class="days-left tw-text-gray-700"
      >{{ daysLeft() }} days left</span
    >
  </div>
</ng-template>
